const styles = (theme) => ({
  fields: {
    minHeight: 270,
  },
});

export default styles;
